
export const useSalesNet = (salesNetModel : {salesNet: number, totalTransactions: number}) => {
  const statSalesNet: StatItem[] = [
    {label: 'Transacciones', value: salesNetModel.totalTransactions },
    {label: 'Monto bruto', value: salesNetModel.salesNet, textAlign: 'right' as const, hasFormat: true},
  ]

  return {
    statSalesNet
  }
}
